import React from 'react';
import ModalDefault from '../../ModalDefault';
import ButtonDefault from '../../form/ButtonDefault';
import { IconClose } from '../../icons';
import { ModalWrapper, ModalTitle, ModalButtons } from '../../../pages/Demanda/styles';
import styled from 'styled-components';

const ContentWrapper = styled.div`
    width: 100% !important;
    box-sizing: border-box;
    padding: 20px 0;
    text-align: center;
    color: ${({ theme }) => theme.colors.interfaceText400};
    font-size: 14px;
    line-height: 20px;
`;

interface ModalReabrirExecucaoProps {
    modalAtivo: boolean;
    setModalAtivo: (ativo: boolean) => void;
    onConfirmar: () => Promise<void>;
    loading?: boolean;
}

export default function ModalReabrirExecucao({ 
    modalAtivo, 
    setModalAtivo, 
    onConfirmar,
    loading = false
}: ModalReabrirExecucaoProps) {
    const handleConfirmar = async () => {
        await onConfirmar();
    };

    const handleCancelar = () => {
        setModalAtivo(false);
    };

    return (
        <ModalDefault
            id={'overlayModal'}
            onClose={handleCancelar}
            openModal={modalAtivo}
            width="520px"
        >
            <ModalWrapper>
                <ModalTitle>
                    <div className="points">
                        Reabrir execução
                    </div>
                    <div
                        className="close"
                        onClick={handleCancelar}
                    >
                        <IconClose />
                    </div>
                </ModalTitle>

                <ContentWrapper>
                    Tem certeza que deseja reabrir a execução desta demanda?
                </ContentWrapper>

                <ModalButtons>
                    <ButtonDefault
                        className="cancel"
                        onClick={handleCancelar}
                        disabled={loading}
                    >
                        Cancelar
                    </ButtonDefault>
                    <ButtonDefault
                        className="continue"
                        onClick={handleConfirmar}
                        disabled={loading}
                    >
                        {loading ? 'Processando...' : 'Confirmar'}
                    </ButtonDefault>
                </ModalButtons>
            </ModalWrapper>
        </ModalDefault>
    );
}


